<template>
  <div class="c-nav-combination-layout">
    <div class="l-flex l-flex--column">
      <banner
        v-for="item in banners"
        :key="item.i"
        v-bind="item.data"
      />
      <div class="c-nav-combination-layout__nav-items l-grid l-grid--2-col-first-long l-grid--align-start">
        <div class="l-grid l-grid--2-col">
          <nav-card
            v-for="item in navItems"
            :key="item.i"
            v-bind="item"
          />
        </div>
        <div>
          <landing-page-card
            v-for="item in twoRowNavItems"
            :key="item.i"
            v-bind="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../banner/Banner.vue";
import LandingPageCard from '../card/LandingPageCard.vue';
import NavCard from "../nav/sharedComponents/NavCard.vue";
export default {
  components: { NavCard, Banner, LandingPageCard },
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
    navItems: {
      type: Array,
      default: () => [],
    },
    twoRowNavItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.c-nav-combination-layout{
  &__nav-items {
    margin-top: rem(20px);
}
}
</style>
